/* src/app/requests/request-detail/request-detail.component.scss */
.request-view {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 100%;
}
.request-view__detail {
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  flex-grow: 1;
  flex-shrink: 1;
  padding: 20px;
  white-space: normal;
  word-wrap: break-word;
  overflow-y: auto;
  overflow-x: hidden;
}
.request-view__detail .dd_table {
  overflow: auto;
}
.request-view__detail dt {
  margin-bottom: 0.5rem;
  font-size: 15px;
}
.request-view__detail table thead tr th {
  font-size: 15px;
}
.request-view__log {
  flex-grow: 0;
  flex-shrink: 0;
  width: 300px;
  overflow: auto;
}
@media (max-width: 520px) {
  .request-view__log {
    width: 100% !important;
  }
}
.fa-copy:hover {
  color: black;
  transition: none;
}
.fa-unlock {
  font-size: 12px;
  padding-right: 7px;
}
.btn_close-request-view {
  display: none;
  padding: 0;
}
.btn-back {
  display: none;
  align-items: center;
  position: relative;
  width: 100%;
  height: 35px;
  text-align: left;
  background-color: transparent;
  border: none;
  text-decoration: none;
  padding: 10px 10px 10px;
  border-radius: 0;
}
.btn-back:hover {
  background-color: #f1f3f4;
}
.btn-back .back-icon {
  width: auto;
  height: 100%;
  padding: 0px 5px;
}
.request-title {
  font-size: 24px;
}
.file-link {
  padding: 5px 10px;
  color: black;
  font-size: 18px;
  cursor: pointer;
}
.file-link:hover {
  color: #4dadf7;
}
.right-panel {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  background-color: #ffffff !important;
  border-left: 1px solid #d6d8db;
  max-width: 300px;
  width: 100%;
  height: 100%;
  overflow: auto;
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0, 0, 0.3, 1);
  z-index: 8;
}
.right-panel.closed {
  transform: translateX(100%);
  width: 100%;
}
.main-content {
  transition: padding 0.3s cubic-bezier(0, 0, 0.3, 1);
  padding-right: 320px;
  overflow-x: hidden;
  min-height: 100%;
}
.main-content.right-panel-closed {
  padding-right: 20px;
}
@media (max-width: 1000px) {
  .main-content {
    padding: 20px;
  }
  .btn-back {
    display: flex;
  }
}
/*# sourceMappingURL=request-detail.component.css.map */
